// --- Dynamic questionnaire schema ---
export const QUESTION_GROUPS = [
    {
        key: "no_qr",
        title: "Jag fick ingen QR-kod",
        subject: "Ingen QR-kod",
        fields: [
            { key: "when", label: "När gjorde du köpet? (datum och tid)", type: "datetime", required: true },
            { key: "product", label: "Vilken produkt försökte du handla?", type: "text", required: false },
            { key: "payment", label: "Vilken betalmetod använde du?", type: "select", required: false, options: ["Kort", "Swish", "Apple Pay", "Google Pay", "Annat"] },
        ],
    },
    {
        key: "qr_failed",
        title: "QR-koden fungerade inte",
        subject: "QR-kod fungerade inte",
        fields: [
            { key: "when", label: "När försökte du använda QR-koden? (datum och tid)", type: "datetime", required: true },
            { key: "what_happened", label: "Vad hände när du försökte scanna koden?", type: "textarea", required: true, placeholder: `t.ex. "felkod", "inget hände"` },
            { key: "device", label: "Vilken enhet försökte du handla på?", type: "text", required: false },
        ],
    },
    {
        key: "oos",
        title: "Produkten fanns inte eller var slut",
        subject: "Produkt saknas",
        fields: [
            { key: "when", label: "När öppnade du kylen/skåpet? (datum och tid)", type: "datetime", required: true },
            { key: "product", label: "Vilken produkt letade du efter?", type: "text", required: true },
            { key: "unit", label: "Vilken enhet handlade du från?", type: "text", required: false },
            { key: "took_other", label: "Tog du något annat istället?", type: "textarea", required: false },
        ],
    },
    {
        key: "lock_error",
        title: "Fel på lås eller öppningsmekanism",
        subject: "Fel på lås/öppning",
        fields: [
            { key: "when", label: "När uppstod felet? (datum och tid)", type: "datetime", required: true },
            { key: "what_happened", label: "Vad hände när du försökte öppna/stänga?", type: "textarea", required: true },
            { key: "unit", label: "Var detta i en specifik enhet/kyl? (plats eller ID)", type: "text", required: false },
            { key: "could_buy", label: "Kunde du ändå genomföra köpet?", type: "select", options: ["Ja", "Nej"], required: false },
        ],
    },
    {
        key: "payment",
        title: "Problem med betalning",
        subject: "Betalningsproblem",
        fields: [
            { key: "when", label: "När gjorde du köpet? (datum och tid)", type: "datetime", required: true },
            { key: "method", label: "Vilken betalmetod använde du?", type: "select", options: ["Kort", "Swish", "Apple Pay", "Google Pay", "Annat"], required: true },
            { key: "what", label: "Vad var problemet? (t.ex. dubbeldebitering, betalning misslyckades)", type: "textarea", required: true },
        ],
    },
    {
        key: "expired",
        title: "Produktens giltighetstid hade gått ut",
        subject: "Utgången produkt",
        fields: [
            { key: "when", label: "När köpte du produkten? (datum och tid)", type: "datetime", required: true },
            { key: "product", label: "Vilken produkt gäller det?", type: "text", required: true },
            { key: "issue", label: "Hur var produkten skadad/felaktig?", type: "textarea", required: true },
        ],
    },
    {
        key: "tech",
        title: "Tekniskt fel i appen eller webben",
        subject: "Tekniskt fel",
        fields: [
            { key: "os", label: "Vilket operativsystem använder du? (iOS, Android, annat)", type: "text", required: false },
            { key: "device", label: "Vilken enhet använder du? (iPhone, Android, annat)", type: "text", required: false },
            { key: "action", label: "Vad försökte du göra när felet uppstod?", type: "textarea", required: true },
            { key: "error", label: "Fick du något felmeddelande?", type: "textarea", required: false },
            { key: "when", label: "När inträffade felet? (datum och tid)", type: "datetime", required: true },
        ],
    },
    {
        key: "refund",
        title: "Återbetalning eller reklamation",
        subject: "Återbetalning/Reklamation",
        fields: [
            { key: "product", label: "Vilken produkt gäller det?", type: "text", required: true },
            { key: "when", label: "När köpte du produkten? (datum och tid)", type: "datetime", required: true },
            { key: "why", label: "Varför vill du ha återbetalning/reklamera?", type: "textarea", required: true },
        ],
    },
    {
        key: "other",
        title: "Annat",
        subject: "Annat ärende",
        fields: [
            { key: "desc", label: "Beskriv ärendet så tydligt som möjligt", type: "textarea", required: true },
            { key: "when", label: "När inträffade detta? (datum och tid)", type: "datetime", required: false },
            { key: "unit", label: "Vilken enhet gällde det?", type: "text", required: false },
        ],
    },
];
